import { useCallback } from 'react';
import { useQuery } from 'data-fetching-client';
import Raven from 'raven-js';
import { GET_RECOMMENDED_ROLLOUT_PRODUCT_UPDATES, GET_ROLLOUT_PRODUCT_UPDATES } from '../queries';
import useUpdatePUTableCache from './useUpdatePUTableCache';

/**
 * This hook fetches the relevant product updates to load on the page
 */
const useFetchProductUpdates = ({
  category,
  paramsForGetRolloutProductUpdates,
  portalId,
  setCacheUpdated,
  userId,
  validatePUData
}) => {
  const {
    addToCache
  } = useUpdatePUTableCache();
  const updateRolloutCache = useCallback(productUpdates => {
    addToCache(productUpdates);
    setCacheUpdated(true);
  }, [addToCache, setCacheUpdated]);
  const onCompleted = useCallback(fetchedData => {
    const productUpdates = fetchedData ? fetchedData.rolloutProductUpdates.rolloutProductUpdates : [];
    const errors = new Map();
    productUpdates.forEach(pu => {
      const errorMessage = validatePUData(pu);
      if (errorMessage) {
        errors.set(`productUpdateId: ${pu.id}`, errorMessage);
      }
    });
    if (errors.size > 0) {
      Raven.captureMessage('Invalid product update data', {
        extra: {
          userId,
          portalId,
          errors: JSON.stringify(Array.from(errors))
        }
      });
    }
    updateRolloutCache(productUpdates);
  }, [portalId, updateRolloutCache, userId, validatePUData]);
  const {
    data: recommendedData,
    error: recommendedError,
    loading: recommendedLoading
  } = useQuery(GET_RECOMMENDED_ROLLOUT_PRODUCT_UPDATES, {
    fetchPolicy: 'cache-and-network',
    variables: paramsForGetRolloutProductUpdates,
    skip: category !== 'recommended',
    onCompleted
  });
  const {
    data: rolloutProductUpdatesData,
    error: rolloutProductUpdatesError,
    loading: rolloutProductUpdatesLoading
  } = useQuery(GET_ROLLOUT_PRODUCT_UPDATES, {
    fetchPolicy: 'cache-and-network',
    variables: paramsForGetRolloutProductUpdates,
    skip: category === 'recommended',
    onCompleted
  });
  if (category === 'recommended') {
    return {
      data: recommendedData,
      loading: recommendedLoading,
      error: recommendedError
    };
  } else {
    return {
      data: rolloutProductUpdatesData,
      error: rolloutProductUpdatesError,
      loading: rolloutProductUpdatesLoading
    };
  }
};
export default useFetchProductUpdates;